const firebaseConfig = {
    apiKey: "AIzaSyCtk9Z1GV7NA-GnHM4DMHLiHoJb-lGdlN0",
    authDomain: "tourismofsylhet-f988d.firebaseapp.com",
    projectId: "tourismofsylhet-f988d",
    storageBucket: "tourismofsylhet-f988d.appspot.com",
    messagingSenderId: "622146996902",
    appId: "1:622146996902:web:5ede49af4f195b3df60267"
};
export default firebaseConfig;